import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Features from "./components/Features";
import Footer from "./components/Footer";
import Join from "./Join"
import Form from "./Form"
import "./App.css";

function App() {
  return (
    <>
      <Navbar />
      <Routes>

        <Route
          path="/"
          element={
            <>
            <Hero />
        <About />
        <Features />
        </>
          }
        
        />

        <Route
          path="/join"
          element={<Join/>}
        />

        <Route
          path="/form"
          element={<Form/>}
        />

         

      </Routes>
     
        <Footer />
    </>
  );
}

export default App;
